export default {
  orderId: {
    id: 'sourcing_page_filters_order_id',
    defaultMessage: 'Order ID',
  },
  status: {
    id: 'sourcing_page_filters_status',
    defaultMessage: 'Status',
  },
  suspendReason: {
    id: 'sourcing_page_filters_suspend_reason',
    defaultMessage: 'Suspend reason',
  },
  trackingNumber: {
    id: 'sourcing_page_filters_tracking_number',
    defaultMessage: 'Tracking number',
  },
  creationDateMax: {
    id: 'sourcing_page_filters_creation_date_max',
    defaultMessage: 'To',
  },
  creationDateMin: {
    id: 'sourcing_page_filters_creation_date_min',
    defaultMessage: 'Orders created from',
  },
  customer: {
    id: 'sourcing_page_filters_customer',
    defaultMessage: 'Customer',
  },
  market: {
    id: 'sourcing_page_filters_market',
    defaultMessage: 'All markets',
  },
  reset: {
    id: 'sourcing_page_filters_reset',
    defaultMessage: 'Reset',
  },
  apply: {
    id: 'sourcing_page_filters_apply',
    defaultMessage: 'Apply',
  },
  seeMore: {
    id: 'sourcing_page_filters_see_more',
    defaultMessage: 'See more filters',
  },
  seeLess: {
    id: 'sourcing_page_filters_see_less',
    defaultMessage: 'See less filters',
  },
}
